import React from "react";
import "./worldSpiritsCard.scss";
import AwardCard from "components/AwardCard/index";
import worldSpiritsImage from "assets/NewBanner/WorldSpiritsImage.png";
import { awardCardData } from "components/AwardCard/awardCardData";

/**
 * ADI Card Component
 * @param {Object} props - Component props
 * @param {string} props.title - Card title
 * @returns {JSX.Element} ADI Card component
 */
const WorldSpiritsCard = ({ title = "Awards" }) => {
  return (
    <div className="worldSpiritsCardContainer">
      <div className="mainCard">
        <div className="worldSpiritsCardHeader">
          <img
            src={worldSpiritsImage}
            alt="Card Logo"
            className="worldSpiritsCardLogo"
          />
          <h2 className="worldSpiritsCardTitle">
            San Francisco World Spirits Competition
          </h2>
          <span className="worldSpiritsCardDescription">
            The San Francisco Spirits Competition is one of the most respected
            competitions in the world, judged by a panel of top industry experts
            through blind tastings.{" "}
          </span>
        </div>

        <div className="awardsContainer">
          <div className="awardItem">
            <AwardCard {...awardCardData.dualProductsOne} />
          </div>

          <div className="awardItem">
            <AwardCard {...awardCardData.dualProductsTwo} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorldSpiritsCard;
